import { Component } from 'react';
import styles from './nfoSection.scss';
import { Heading } from '../../common/heading';
import { ViewAll } from '../../common/viewAll';
import { Link } from '../../../configs/routes';
import { WhyNfo } from '../../nfoPage/whyNfo/whyNfo';

import Loader from '../../../components/ui/Loader';
import { CDN_CLRSAVE_URL } from '../../../constants';
import { nfoListing } from '../../../query/nfo';
import { getFundDetailsGraphql } from '../../../utils';

interface State {
  listData: any;
}
export class NFOSection extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      listData: null,
    };
  }

  public componentDidMount() {
    getFundDetailsGraphql(nfoListing).then((resp) => {
      if (resp && resp.data) {
        this.setState({
          listData: resp.data,
        });
      }
    });
  }

  public render() {
    const { listData } = this.state;
    return (
      <div id="new-fund-offer" className="lil-container lil-mt-16 sm:lil-mt-12">
        <div>
          <Heading
            title="New fund offers (NFO)"
            sub="Early investment opportunity to invest in newly launched funds"
          />
          <div>
            {!listData ? (
              <Loader />
            ) : (
              <div className="lil-flex lil-flex-wrap">
                {[
                  ...listData.getNfos.liveNfos,
                  ...listData.getNfos.closedNfos,
                  ...listData.getNfos.upcomingNfos,
                ]
                  .slice(0, 3)
                  .map((ele) => {
                    return (
                      <Link
                        route={`/mutual-funds/nfo/${ele.parentSlug}/${ele.slug}/${ele.isinCode}`}
                        key={ele.productId}
                      >
                        <div className="lil-w-1/3 lil-pr-5 lil-mt-10 lil-cursor-pointer sm:lil-w-full sm:lil-pr-0">
                          <div
                            className={
                              ele.nfoMetadata.nfoState.toLowerCase() === 'live'
                                ? `lil-rounded-xl ${styles['live-bg-color']}`
                                : ele.nfoMetadata.nfoState.toLowerCase() ===
                                  'upcoming'
                                ? `lil-rounded-xl ${styles['upcoming-bg-color']}`
                                : `lil-rounded-xl ${styles['closed-bg-color']} lil-h-full`
                            }
                            // className={`lil-rounded-xl ${styles['live-bg-color']}`}
                          >
                            <div className="lil-flex lil-justify-between lil-pt-6 lil-px-4 lil-w-full">
                              <div className="lil-flex lil-items-center">
                                <img
                                  src={`${CDN_CLRSAVE_URL}/clearsave${ele.imageUrl}`}
                                  alt="logo"
                                  width="30"
                                  height="30"
                                />
                                <div className="lil-font-semibold lil-pl-4 lil-pr-6">
                                  {ele.fundName.length > 36
                                    ? ele.fundName.slice(0, 36) + '...'
                                    : ele.fundName}
                                </div>
                              </div>
                              <div className="lil-pt-1">
                                {ele.nfoMetadata.nfoState.toLowerCase() ===
                                  'live' && (
                                  <div
                                    className={`lil-flex lil-items-center lil-pl-1 lil-pr-4 lil-rounded-md ${styles['btn-red']}`}
                                  >
                                    <img
                                      src="https://assets1.cleartax-cdn.com/cleartax/images/1636449441_group18141235.svg"
                                      alt="dot"
                                    />
                                    <p className="lil-text-s-12 lil-font-bold lil-pl-1 lil-text-white">
                                      {ele.nfoMetadata.nfoState.toUpperCase()}
                                    </p>
                                  </div>
                                )}
                                {ele.nfoMetadata.nfoState.toLowerCase() ===
                                  'upcoming' && (
                                  <div
                                    className={`lil-flex lil-items-center lil-px-2 lil-rounded-md ${styles['btn-blue']}`}
                                  >
                                    <p className="lil-text-s-12 lil-font-bold lil-text-white">
                                      {ele.nfoMetadata.nfoState.toUpperCase()}
                                    </p>
                                  </div>
                                )}
                                {ele.nfoMetadata.nfoState.toLowerCase() ===
                                  'closed' && (
                                  <div
                                    className={`lil-flex lil-items-center lil-px-2 lil-rounded-md ${styles['btn-yellow']}`}
                                  >
                                    <p className="lil-text-s-12 lil-font-bold lil-text-white">
                                      {ele.nfoMetadata.nfoState.toUpperCase()}
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="lil-mt-3 lil-py-4 lil-pl-16 lil-text-s-14">
                              <div>
                                Invest by <b>{ele.nfoMetadata.closeDate}</b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
              </div>
            )}
          </div>
        </div>

        <ViewAll
          title="View all NFOs"
          link="/mutual-funds/nfo"
          classes="lil-mt-10"
        />

        <WhyNfo headerClass="" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/homePageNew/nfoSection/nfoSection.tsx